module.exports = __webpack_public_path__ + "static/media/poi_emergency_multi.3f0870d9.svg";